export const getFormVariables = event =>
  Array.from(event.currentTarget.elements).reduce(
    (variables, { name, value }) =>
      name && value ? { ...variables, [name]: value } : variables,
    {}
  );
